import '../schema/lex-state-object';
/**
 * Extracts the properties from the event stream that are required for sp1
 * BQ table population.
 *
 * @param {{
 *   evt: {
 *     detail: LexStateObject
 *   }
 * }} evt - Lex State object containing mutated key:value pairs about the event state.
 * @returns {{
 *    session_id: string,
 *    qnabot_qid: string,
 *    q: string,
 *    qnabot_gotanswer: string,
 *    dbNavTitle: string | null,
 *    resCardButtons: Array<{text: string, value: string}>,
 *    dbNav: string,
 *    message: string,
 *    qid: string
 * }}
 */
function extractStateObjectProps(evt) {
  const { state } = evt.detail;
  const session_id = state.sessionId || '';
  const messageObj = JSON.parse(state.message || '{}');
  const { messages } = messageObj;
  const message = messages && messages.length ? messages[0].value : '' || '';
  const resCardObject = state.responseCard || {};
  const { genericAttachments } = resCardObject;
  const resCardButtons = genericAttachments && genericAttachments.length ? genericAttachments[0].buttons : [] || [];
  const sessionAttributes = state.sessionState.sessionAttributes || {};
  const {
    qnabot_qid,
    qnabot_gotanswer,
    qnabotcontext,
    dbNav,
    dbNavTitle,
  } = sessionAttributes;
  const qnaContextObj = JSON.parse(qnabotcontext || '{}');
  const qnaContextPrev = qnaContextObj && qnaContextObj.previous ? qnaContextObj.previous : {} || {};
  const {
    q,
    qid,
  } = qnaContextPrev;

  return {
    session_id,
    dbNav,
    dbNavTitle,
    message,
    resCardButtons,
    qnabot_qid,
    qnabot_gotanswer,
    q,
    qid,
  };
}

export default extractStateObjectProps;
